import { Grid } from '@mui/material';
import TextField from 'components/text-field';
import React, { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import ContainerModal from './modal-container';
import { NewLicenseType } from 'types/new-user';
import { useMutation } from 'react-query';
import graphql from 'services/querys';
import SelectField from 'components/select-field';
import { useTranslation } from 'react-i18next';

type DialogLicenseProps = {
  open: boolean;
  onClose: () => void;
  partyId: string;
  onSuccess: (licenses: NewLicenseType[]) => void;
  states: {
    code: string;
    name: string;
    parent: string;
  }[];
};

type createLicenseForm = {
  number: string;
  state: string;
};

const CreateLicense: FC<DialogLicenseProps> = ({ open, onClose, partyId, onSuccess, states }) => {
  const { t } = useTranslation();
  const { mutate: createLicense, ...responseCreateLicense } = useMutation(graphql.createLicense, {
    onSuccess: (data) => {
      responseCreateLicense.reset();
      onSuccess(data.createLicense?.licenses || []);
      onClose();
    },
  });
  const methods = useForm<createLicenseForm>({
    defaultValues: {
      number: '',
      state: '',
    },
  });

  const { control } = methods;
  const isSaving = responseCreateLicense.isLoading;

  return (
    <ContainerModal
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSave={() => {
        methods.handleSubmit((data) => {
          createLicense({
            partyId,
            data: {
              state: data.state,
              number: data.number,
            } as NewLicenseType,
          });
        })();
      }}
      disableSavebutton={!methods.formState.isValid}
      loadingSaveButton={isSaving}
      modalTitle={t('contact:addLicenseModalTitle')}
    >
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <Controller
            control={control}
            name="number"
            rules={{ required: true }}
            render={({ field: { ref, ...field } }) => <TextField {...field} inputRef={ref} disabled={isSaving} label={t('contact:numberLabel')} />}
          />
        </Grid>
        <Grid item>
          <Controller
            control={control}
            name="state"
            rules={{ required: true }}
            render={({ field: { ref, ...field } }) => (
              <SelectField
                {...field}
                inputRef={ref}
                disabled={isSaving}
                label={t('contact:stateLabel')}
                data={states}
                dataKey="code"
                dataValue="code"
                dataText="name"
                handleChange={field.onChange}
              />
            )}
          />
        </Grid>
      </Grid>
    </ContainerModal>
  );
};

export default CreateLicense;
